import $ from 'jquery';
const PHONE_SCREEN_MAX_WIDTH = 768;

export const isPhoneWidth = () => {
    return window.innerWidth < PHONE_SCREEN_MAX_WIDTH + 1;
};

